module.exports = __webpack_public_path__ + "static/media/ITC_F1.d60bcb11.txt";